import React from "react";
import axios from "axios";
import { grey } from "@material-ui/core/colors";
import { fade, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";

import CollectionRateAddForm from "./collection-rate-add-form.component";
import CollectionRateEditForm from "./collection-rate-edit-form.component";
import CollectionRateDeleteForm from "./collection-rate-delete-form.component";
import SkeletonCard from "../../../common/skeleton.component";

import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";

const useStyles = makeStyles((theme) => ({
  table: {
  //  minWidth: 1200,
  },
  tableHead: {
    backgroundColor: fade(theme.palette.primary.dark, 0.85),
    color: theme.palette.info.light,
  },
  tableSubHead: {
    backgroundColor: grey[300],
    color: theme.palette.primary.dark,
  },
  tableRow: {
    hover: {
      cursor: "pointer",
    },
  },
  columnBorder: {
    borderRight: `1px solid ${grey[300]}`,
  },
}));

export default function CollectionRates({
  collectionPointId,
}) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [collectionRates, setCollectionRates] = React.useState([]);

  React.useEffect(() => {
    axios
      .get(`collection-points/${collectionPointId}/rates`)
      .then((response) => {

        if (response.data.status === "success") {
          setCollectionRates(response.data.data);
        }
        setLoading(false);
      })
      .catch((error) => {

        setLoading(false);
      });
  }, []);

  const addCollectionRate = (rate) => {
    collectionRates.push(rate);
    setCollectionRates(collectionRates.map((item) => item));
  };

  const updateCollectionRate = (rate) => {
    setCollectionRates(
      collectionRates.map((item) => (item.id !== rate.id ? item : rate))
    );
  };

  const removeCollectionRate = (rateId) => {
    setCollectionRates(collectionRates.filter((item) => item.id !== rateId));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return collectionRates.length > 0 ? (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table className={classes.table} aria-label="table" size="small">
          <TableHead>
            <TableRow>
              <TableCell align={"center"} className={classes.tableSubHead}>
                Speed
              </TableCell>

              <TableCell
                align={"center"}
                className={classes.tableSubHead}
                align={"center"}
              >
                Cost (£)
              </TableCell>

              <TableCell align={"center"} className={classes.tableSubHead}>
                Available
              </TableCell>
              <TableCell className={classes.tableSubHead} align={"center"}>
                <CollectionRateAddForm
                  collectionPointId={collectionPointId}
                  addCollectionRate={addCollectionRate}
                />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {collectionRates.map((rate, index) => (
              <TableRow hover tabIndex={-1} key={rate.id}>
                <TableCell align={"center"} className={classes.columnBorder}>
                  {rate.note === null || rate.note === "" ? (
                    <Chip variant="outlined" label={rate.speed} />
                  ) : (
                    <Tooltip title={rate.note} placement="top">
                      <Chip label={rate.speed} />
                    </Tooltip>
                  )}
                </TableCell>

                <TableCell align={"center"} className={classes.columnBorder}>
                  {rate.cost}
                </TableCell>

                <TableCell align={"center"} className={classes.columnBorder}>
                  {rate.available === 1 ? (
                    <CheckIcon color="primary" fontSize="small" />
                  ) : (
                    <CloseIcon color="secondary" fontSize="small" />
                  )}
                </TableCell>
                <TableCell align={"center"} width="140">
                  <React.Fragment>
                    <CollectionRateEditForm
                          rate={rate}
                          updateCollectionRate={updateCollectionRate}
                          key={index}
                        />
                    <CollectionRateDeleteForm
                          rate={rate}
                          removeCollectionRate={removeCollectionRate}
                        />
                  </React.Fragment>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  ) : (
    <CollectionRateAddForm
      collectionPointId={collectionPointId}
      addCollectionRate={addCollectionRate}
      fullButton={true}
    />
  );
}
